module.exports = __webpack_public_path__ + "static/map-9ff62fcc04fac368fbc9ce36c5255b4a.svg";